import { Component, Input, SimpleChanges, OnChanges } from '@angular/core';
import { LedgersService } from 'src/app/share/services/ledgers/ledgers.service';
import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';
import { CommonServiceService } from 'src/app/share/services/common-service/common-service.service';

@Component({
  selector: 'app-performance-highlights',
  templateUrl: './performance-highlights.component.html',
  styleUrls: ['./performance-highlights.component.scss'],
  standalone: false
})
export class PerformanceHighlightsComponent implements OnChanges {
  @Input() selectedTyre: any;
  @Input() selectedRange: any;

  loader: boolean = false;
  errorMessage: string = '';
  faExclamationTriangle = faExclamationTriangle;
  displayMoment: string = '';

  highlights: any = {}

  constructor(
    private readonly ledgersService: LedgersService,
    private readonly cmnService: CommonServiceService,
  ) { }


  ngOnChanges(changes: SimpleChanges): void {
    if (changes['selectedRange']?.currentValue) {
      if (this.selectedRange) {
        this.getHighlights();
      }
    }
  }


  createPeriod() {
    if (this.selectedRange.period == 7) {
      this.displayMoment = 'Movement in last week';
      return 'week';
    } else if (this.selectedRange.period == 30) {
      this.displayMoment = 'Movement in last month';
      return 1;
    } else if (this.selectedRange.period == 90) {
      this.displayMoment = 'Average movement per month';
      return 3;
    } else if (this.selectedRange.period == 180) {
      this.displayMoment = 'Average movement per month';
      return 6
    } else {
      this.displayMoment = 'Average movement per month';
      return 12
    }
  }

  getHighlights() {
    this.loader = true;
    this.errorMessage = '';
    let period = this.createPeriod();
    let payload: any = {
      tyreSize: this.selectedTyre.tyreSize,
      tyreMake: this.selectedTyre.tyreMake,
      tyreModel: this.selectedTyre.tyreModel,
      created_datefrom: this.selectedRange.startDate,
      created_dateupto: this.selectedRange.endDate,
      period: period,
    }
    this.ledgersService.getPerformanceHighlights(payload).subscribe({
      next: (res: any) => {
        if (res.data) {
          this.mapresponse(res.data)
        } else {
          this.errorMessage = 'Something went wrong';
        }
        this.loader = false;
      },
      error: (err: any) => {
        this.loader = false;
        this.errorMessage = err.error.message || 'Something went wrong';
      }
    })
  }


  mapresponse(res: any) {
    this.highlights = {
      keyMetrics: {
        topBuyer: res.topBuyer.buyerName || '',
        itemsSold: this.cmnService.parseNumberOrZero(res?.soldQuantity),
        mostSoldAt: res.topBranch.branchName || '',
        avgPrice: this.cmnService.parseNumberOrZero(res?.avgDealerPrice),
      },
      lastSale: {
        date: res.lastSale.date
          ? new Date(res.lastSale.date).toLocaleDateString('en-GB', {
            day: '2-digit',
            month: 'short',
            year: 'numeric',
            timeZone: 'Asia/Kolkata'
          })
          : '',
        price: this.cmnService.parseNumberOrZero(res?.lastSale?.price),
        quantity: res.lastSale.quantity || 0,
      },
      priceTrend: {
        lowest: this.cmnService.parseNumberOrZero(res?.lowSellingPrice),
        average: this.cmnService.parseNumberOrZero(res?.avgCustomerPrice),
        highest: this.cmnService.parseNumberOrZero(res?.highSellingPrice),
      },
      notMovedIn: this.cmnService.parseNumberOrZero(res?.lastSale?.daysAgo),
      notMovedMsg: `Hasn't moved in ${res?.lastSale?.daysAgo ? res?.lastSale?.daysAgo : 0} days`,
      avg: {
        avgInwards: this.cmnService.parseNumberOrZero(res?.avgInwards),
        avgOutwards: this.cmnService.parseNumberOrZero(res?.avgOutwards),
      }
    }
  }

}
